<template>
  <div>
    <div class="title">Инструкция</div>
    <div class="divider"></div>
    <div class="instruction__content">
      <div class="swiper-container">
        <div class="swiper-wrapper">
          <div class="swiper-slide">
            <div class="slide-text">
              <p class="title">1. Шаг</p>
              <p>
                Для начала вам нужно найти игровой мод
                <span>Red Bull River Runes</span> в Мастерской и подписаться на
                него
              </p>
            </div>
            <div class="slide-img">
              <img
                src="@/assets/img/slide-1.png"
                @click="openImg(require('@/assets/img/full-slide-1.jpg'))"
                alt="Слайд шага 1"
              />
            </div>
          </div>
          <div class="swiper-slide">
            <div class="slide-text">
              <p class="title">2. Шаг</p>
              <p>
                Далее заходим в <span>игротеку</span> и ищем River Runes. Жмем
                кнопку <span>"Установить"</span>. Теперь вы готовы создавать
                лобби!
              </p>
            </div>
            <div class="slide-img">
              <img
                src="@/assets/img/slide-2.png"
                @click="openImg(require('@/assets/img/full-slide-2.jpg'))"
                alt="Слайд шага 2"
              />
            </div>
          </div>
          <div class="swiper-slide">
            <div class="slide-text">
              <p class="title">3. Шаг</p>
              <p>
                Вы можете создать два типа лобби — открытое и закрытое. Для
                быстрого поиска игры просто нажмите
                <span>"Играть в River Runes"</span>. Также, на данной странице
                вы можете перейти в чат, создать собственное лобби и удалить мод
              </p>
            </div>
            <div class="slide-img">
              <img
                src="@/assets/img/slide-3.png"
                @click="openImg(require('@/assets/img/full-slide-3.jpg'))"
                alt="Слайд шага 3"
              />
            </div>
          </div>
          <div class="swiper-slide">
            <div class="slide-text">
              <p class="title">4. Шаг</p>
              <p>
                Теперь делаем все настройки. если вы хотите закрытое лобби, то
                вам нужно придумать пароль и нажать кнопку
                <span>"Создать"</span>. На этапе создания вы можете все отменить
                и вернуться в предыдущее меню
              </p>
            </div>
            <div class="slide-img">
              <img
                src="@/assets/img/slide-4.png"
                @click="openImg(require('@/assets/img/full-slide-4.jpg'))"
                alt="Слайд шага 4"
              />
            </div>
          </div>
          <div class="swiper-slide">
            <div class="slide-text">
              <p class="title">5. Шаг</p>
              <p>
                После создания лобби вы сможете увидеть список игроков и начать
                общаться в чате лобби
              </p>
            </div>
            <div class="slide-img">
              <img
                src="@/assets/img/slide-5.png"
                @click="openImg(require('@/assets/img/full-slide-5.jpg'))"
                alt="Слайд шага 5"
              />
            </div>
          </div>
          <div class="swiper-slide">
            <div class="slide-text">
              <p class="title">6. Шаг</p>
              <p>После запуска лобби принимаем игру как в обычной игре</p>
            </div>
            <div class="slide-img">
              <img
                src="@/assets/img/slide-6.png"
                @click="openImg(require('@/assets/img/full-slide-6.jpg'))"
                alt="Слайд шага 6"
              />
            </div>
          </div>
          <div class="swiper-slide">
            <div class="slide-text">
              <p class="title">7. Шаг</p>
              <p>
                После того, как вы присоединитесь к игре, вам станет доступен
                выбор страны и формат матча. После выбора принимаем все
                настройки и готовимся к игре
              </p>
            </div>
            <div class="slide-img">
              <img
                src="@/assets/img/slide-7.png"
                @click="openImg(require('@/assets/img/full-slide-7.jpg'))"
                alt="Слайд шага 7"
              />
            </div>
          </div>
          <div class="swiper-slide">
            <div class="slide-text">
              <p class="title">8. Шаг</p>
              <p>
                После того, как вы присоединитесь к игре, вам станет доступен
                выбор страны и формат матча. После выбора принимаем все
                настройки и готовимся к игре
              </p>
            </div>
            <div class="slide-img">
              <img
                src="@/assets/img/slide-8.png"
                @click="openImg(require('@/assets/img/full-slide-8.jpg'))"
                alt="Слайд шага 8"
              />
            </div>
          </div>
        </div>
        <div class="swiper-pagination"></div>

        <div class="swiper-button-prev">
          <SvgIcon size="30" name="caret-down" />
        </div>
        <div class="swiper-button-next">
          <SvgIcon size="30" name="caret-down" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Swiper from "swiper";
import showImage from "@/services/common/showImage";

export default {
  data: () => ({
    swiper: null
  }),

  mounted() {
    if (this.swiper) return;

    this.swiper = new Swiper(".swiper-container", {
      pagination: {
        clickable: true,
        el: ".swiper-pagination",
        type: "bullets"
      },
      navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev"
      },
      fadeEffect: {
        crossFade: true
      }
    });
  },

  methods: {
    async openImg(src) {
      await showImage(src);
    }
  }
};
</script>

<style lang="scss">
.modal.lobby-instruction {
  .modal-card {
    padding: 40px 30px;

    .swiper-button {
      &-prev,
      &-next {
        background: none;
        height: 30px;
        top: 55%;
        margin-top: -15px;
        display: inline-flex;
        align-items: center;
        width: auto;
      }

      &-prev {
        transform: rotate(90deg);
      }

      &-next {
        transform: rotate(-90deg);
      }
    }

    .swiper-slide {
      overflow: hidden;

      p {
        font-size: 16px;
        line-height: 22px;
        margin-bottom: 10px;
      }
      p.title {
        font-weight: bold;
        font-size: 24px;
        line-height: 33px;
      }
    }

    .swiper-pagination {
      position: static;
      margin-top: 30px;

      &-bullet {
        background: rgba(#fff, 0.5);

        &-active {
          background: gradient(#5bcdff, #1480b2);
        }
      }
    }

    .slide-text {
      text-align: center;
      min-height: 110px;

      span {
        color: #fbc33e;
        font-weight: bold;
      }
    }

    .slide-img {
      img {
        cursor: pointer;
        display: block;
        width: 100%;
      }
    }
  }
}
</style>
